import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { EditProfileComponent } from '@client/app/feature-modules/navigation/profile/edit-profile/components/edit-profile.component';
import { NAVIGATION_STATES } from '@client/app/feature-modules/navigation/states/navigation.state';

@NgModule({
    declarations: [],
    exports: [],
    imports: [
        EditProfileComponent,
        UIRouterModule.forChild({
            states: NAVIGATION_STATES,
        }),
    ],
})
export class NavigationModule {}
